import { directoryReturn } from './canReturnFromStore';
const HOME_KEY = 'customerHomePath';
const isStorePath = path => typeof path === 'string' && /^\/(?!(?:food-delivery|checkout|orders|static|api)\/)[^/?#\\\s]+\/[^/?#\\\s]+\/?$/.test(path);

export const resolveCustomerHome = (pathname, storage, search = '') => {
  // A directly loaded store becomes Home for this tab, including after reloads.
  if (isStorePath(pathname) && !directoryReturn(search)) {
    try { storage?.setItem(HOME_KEY, pathname); } catch { /* Storage can be disabled. */ }
    return pathname;
  }
  try {
    const saved = storage?.getItem(HOME_KEY);
    if (isStorePath(saved)) return saved;
  } catch { /* Fall back to the marketplace when storage is unavailable. */ }
  return '/';
};

// Capture the document's entry URL once, before client-side navigation starts.
let homePath = '/';
if (process.env.REACT_APP_PORTAL_ROLE === 'CUSTOMER') {
  let storage;
  try { storage = window.sessionStorage; } catch { /* Storage can be disabled. */ }
  homePath = resolveCustomerHome(window.location.pathname, storage, window.location.search);
}
export const customerHomePath = homePath;
